import { Phone, MessageCircle, Clock, Shield, Star } from "lucide-react";

const HERO_IMG =
  "https://customer-assets.emergentagent.com/job_swift-toilet-pro/artifacts/7vrcvbfg_IMG_20240211_232022_804.jpg";

export default function Hero() {
  return (
    <section
      id="top"
      className="relative overflow-hidden bg-white"
      data-testid="hero-section"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 pb-16 lg:pt-20 lg:pb-28 text-center fade-up">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border-2 border-blue-700 text-blue-700 text-xs font-bold uppercase tracking-widest" data-testid="hero-badge">
          <Clock className="w-3.5 h-3.5" />
          Binnen gemiddeld 3 dagen klaar
        </div>

        <h1 className="font-display font-bold mt-6 text-3xl sm:text-4xl lg:text-5xl leading-[1.05] tracking-tight">
          Toiletrenovatie in <span className="text-blue-700">3 dagen</span>
          <br />
          v.a. <span className="text-orange-500">€1200</span>
        </h1>

        <p className="mt-6 max-w-2xl mx-auto text-lg text-slate-700 leading-relaxed">
          Een compleet nieuw toilet of badkamer zonder gedoe. Wij verzorgen
          alles — sloop, leidingwerk, tegelwerk en afwerking. Strakke prijs,
          transparante planning, vakwerk gegarandeerd.
        </p>

        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <a
            href="tel:+31615460576"
            className="inline-flex items-center justify-center gap-2 h-14 px-7 rounded-full bg-blue-700 hover:bg-blue-800 text-white font-semibold transition-all shadow-sm hover:shadow-md"
            data-testid="hero-call-btn"
          >
            <Phone className="w-5 h-5" />
            Bel 06 154 60 576
          </a>
          <a
            href="https://wa.me/31615460576?text=Hoi%2C%20ik%20wil%20graag%20info%20over%20een%20toiletrenovatie."
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center justify-center gap-2 h-14 px-7 rounded-full bg-orange-500 hover:bg-orange-600 text-white font-semibold transition-all shadow-sm hover:shadow-md"
            data-testid="hero-whatsapp-btn"
          >
            <MessageCircle className="w-5 h-5" />
            WhatsApp ons
          </a>
        </div>

        {/* Trust row */}
        <div className="mt-10 flex flex-wrap items-center justify-center gap-6 text-sm text-slate-600">
          <div className="flex items-center gap-2" data-testid="trust-rating">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-4 h-4 fill-orange-500 text-orange-500" />
              ))}
            </div>
            <span className="font-semibold text-slate-900">4.9/5</span>
            <span>klantbeoordeling</span>
          </div>
          <div className="flex items-center gap-2" data-testid="trust-warranty">
            <Shield className="w-4 h-4 text-blue-700" />
            <span>2 jaar garantie op werk</span>
          </div>
        </div>

        {/* Centered hero image */}
        <div className="relative mt-14 mx-auto max-w-4xl">
          <div className="absolute -inset-3 bg-blue-700 rounded-[28px] -rotate-1 hidden sm:block" />
          <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-orange-500 rounded-2xl hidden sm:block" />
          <div className="relative rounded-[24px] overflow-hidden border-4 border-white shadow-2xl bg-white">
            <img
              src={HERO_IMG}
              alt="Modern marmer toilet door De Toiletman"
              className="w-full h-[420px] sm:h-[520px] object-cover"
              data-testid="hero-image"
            />
          </div>
          <div className="absolute -bottom-6 left-6 sm:left-10 bg-white border-2 border-slate-900 rounded-2xl px-5 py-3 shadow-xl animate-float-slow" data-testid="hero-price-badge">
            <div className="text-xs uppercase tracking-widest text-slate-500 font-semibold">Vanaf</div>
            <div className="font-display font-bold text-3xl text-slate-900">
              €1200<span className="text-orange-500">.</span>
            </div>
          </div>
        </div>
      </div>

      <div className="h-1 w-full bg-gradient-to-r from-blue-700 via-blue-700 to-orange-500" />
    </section>
  );
}
